import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-filters-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filters-modal.component.html',
  styleUrl: './filters-modal.component.scss'
})
export class FiltersModalComponent implements OnInit{
  @Input() title: string = '';
  @Input() cancelButtonText: string = '';
  @Input() saveButtonText: string = '';
  @Input() showCancelButton: boolean = true;
  @Input() showSaveButton: boolean = true;
  @Input() modalBody!: TemplateRef<any>;
  @Input() saveDisabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isSaveDisabled = true;


  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.saveDisabled$.subscribe((disabled) => {
      this.isSaveDisabled = disabled;
    });
  }

  save(): void {
    if (!this.isSaveDisabled) {
      this.activeModal.close(true);
    }
  }

  cancel(): void {
    this.activeModal.dismiss(false);
  }
}
